import React from 'react';
import SearchField from './SearchField';

export default function SearchDrawer(props) {
  return (
    <div>
      <SearchField {...props} />
    </div>
  )
}
